import React from 'react'
import PartnerSideDefaultDashboard from './PartnerSideDefaultDashboard'
import Header from '../../../Components/Header'
import SingleSignOnSideBar from '../../../Components/SingleSignOnSideBar'
import { useEffect } from 'react'
import buzzer from "../../../asset/images/buzzer.svg"

function PartnerSideDashboard() {
    const identifyFlag = true;
    const partnerFlag = localStorage.getItem("partnerFlag");

    useEffect(()=>{
        if(partnerFlag == "true"){
        sessionStorage.setItem("identifyFlag", identifyFlag)
        }
    }, []);

    return (
        <>
            <Header portal={"TELECALLER"} />
            <SingleSignOnSideBar />
            <main id="main-content">
                <PartnerSideDefaultDashboard />
            </main>
        </>
    )
}

export default PartnerSideDashboard